// extracted by mini-css-extract-plugin
export default {"component":"PopoverNone_component__5T11Y","inner":"PopoverNone_inner__VKBVE","footer":"PopoverNone_footer__QCkkX"};